//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

// Interfaces

interface Sector {
  sectorname: string;
  sectorcode: string; // Assuming sectorcode is a string
}
interface Region {
  regionid: string;
  regionname: string; // Assuming sectorcode is a string
}
interface Site {
  id: number;
  sitename: string;
  sitealias?: string;
  siteid: string;
  sitecode: string;
}

interface SiteState {
  sectors: Sector[]; // Now stores sectors
  regions: Region[]; 
  sites: Site[];
  loading: boolean;
  error: string | null;
}

const initialState: SiteState = {
  sectors: [],  // Stores sector data
  regions: [],   // Stores region data
  sites: [],     // Stores site data
  loading: false,
  error: null,
};
const roleid= Number(localStorage.getItem('roleId'));
const userid= localStorage.getItem('userid');
// Async Thunks

// Fetch Sectors
export const fetchSectors = createAsyncThunk('AdminConfiguration/fetchSectors', async () => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/api/v1/AdminConfiguration/GetAllSectorByUserId`,
      { userid: userid, roleid: roleid }
    );
    const data = response.data;
    if (!data.success) {
      throw new Error(data.errormessage || 'Failed to fetch sectors');
    }
    return data.data.sectors; // Return sectors instead of cafes
  } catch (error: any) {
    throw new Error(error.response?.data?.errormessage || 'Failed to fetch sectors');
  }
});

// Fetch Regions
export const fetchAllRegions = createAsyncThunk(
  'AdminConfiguration/fetchAllRegions',
  async (sectorCode: string) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/AdminConfiguration/GetAllRegionByUserIdAndSector`,
        { userid: userid, roleid: roleid, sectorcode: sectorCode }
      );
      const data = response.data;
      if (!data.success) {
        throw new Error(data.errormessage || 'Failed to fetch regions');
      }
      return data.data.regions; // Return regions filtered by sector
    } catch (error: any) {
      throw new Error(error.response?.data?.errormessage || 'Failed to fetch regions');
    }
  }
);

// Fetch Sites
export const fetchAllSites = createAsyncThunk(
  'AdminConfiguration/fetchAllSites',
  async ({ sector, region }: { sector: string, region: string }) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/AdminConfiguration/GetAllSites`,
        { userid: userid, roleid: roleid, sectorcode: sector, regionid: region }
      );
      const data = response.data;
      if (!data.success) {
        throw new Error(data.errormessage || 'Failed to fetch sites');
      }
      return data.data.sitelist; // Return sites data
    } catch (error: any) {
      throw new Error(error.response?.data?.errormessage || 'Failed to fetch sites');
    }
  }
);

// Slice
const sectorRegionAllSitesSlice = createSlice({
  name: 'sectorRegionAllSitesSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectors.fulfilled, (state, action) => {
        state.sectors = action.payload; // populate sectors
        state.loading = false; // stop loading
      })
      .addCase(fetchAllRegions.fulfilled, (state, action) => {
        state.regions = action.payload; // populate regions
        state.loading = false; // stop loading
      })
      .addCase(fetchAllSites.fulfilled, (state, action) => {
        state.sites = action.payload; // populate sites
        state.loading = false; // stop loading
      })
      .addCase(fetchSectors.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch sectors';
        state.loading = false; // stop loading in case of error
      })
      .addCase(fetchAllRegions.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch regions';
        state.loading = false; // stop loading in case of error
      })
      .addCase(fetchAllSites.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch sites';
        state.loading = false; // stop loading in case of error
      })
      .addCase(fetchSectors.pending, (state) => {
        state.loading = true; // start loading
      })
      .addCase(fetchAllRegions.pending, (state) => {
        state.loading = true; // start loading
      })
      .addCase(fetchAllSites.pending, (state) => {
        state.loading = true; // start loading
      });
  },
});

export default sectorRegionAllSitesSlice.reducer;
